import PropTypes from 'prop-types';
import {useCallback, useEffect, useRef} from 'react';
import {getQueryParam} from 'src/utils/url';
import {
  fireEcommerceEvent,
  fireListingsImpressionsEvents,
  getEcommerceEventPayload,
  getItemEcomerceData,
  getListingImpressionsName
} from './utils/productsAnalytics';

export default function useProductAnalyticsEvents({
  categoryId,
  categoryTree,
  fireProductImpressionsOnLoad = true,
  hits,
  isCustomPage = false,
  isSearchResults = false
}) {
  const hasFiredEvent = useRef(false);

  useEffect(() => {
    if (
      !hasFiredEvent.current &&
      hits.length > 0 &&
      fireProductImpressionsOnLoad
    ) {
      const items = hits.map((hit, index) =>
        getItemEcomerceData(hit, index + 1)
      );
      fireEcommerceEvent(
        getEcommerceEventPayload(
          items,
          categoryId,
          categoryTree,
          getQueryParam('keyword')
        ),
        'view_item_list'
      );
      fireListingsImpressionsEvents(hits);
      hasFiredEvent.current = true;
    }
  }, [hits, fireProductImpressionsOnLoad, categoryId, categoryTree]);

  const fireSelectProductEvent = useCallback(
    (hit, index) => {
      const item = getItemEcomerceData(hit, index, {
        item_list_name: getListingImpressionsName({
          isCustomPage,
          isSearchResults
        })
      });
      const ecommerceEventPayload = getEcommerceEventPayload(
        [item],
        categoryId,
        categoryTree,
        getQueryParam('keyword')
      );
      fireEcommerceEvent(ecommerceEventPayload, 'select_item');
    },
    [categoryId, categoryTree]
  );

  return {fireSelectProductEvent};
}

useProductAnalyticsEvents.propTypes = {
  categoryId: PropTypes.number.isRequired,
  categoryTree: PropTypes.string.isRequired,
  fireProductImpressionsOnLoad: PropTypes.bool,
  hits: PropTypes.array.isRequired,
  isCustomPage: PropTypes.bool,
  isSearchResults: PropTypes.bool
};
